import {Injectable} from '@angular/core';
import {GroupConfig, GroupConfigs} from '../../shared/models/config';
import {GetConfigOrderService} from '../../order/services/get-config-order.service';

@Injectable({
  providedIn: 'root'
})
export class GetConfigSiteService {

  constructor(private getConfigOrderService: GetConfigOrderService) {
  }

  getConfigSiteFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_ADDRESS',
          controlName: ['line1'],
          placeholder: 'GENERIC_ADDRESS',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CITY',
          controlName: ['city'],
          placeholder: 'GENERIC_CITY',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_EXTERNAL_ID',
          controlName: ['extId'],
          placeholder: 'GENERIC_EXTERNAL_ID',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_ZIP',
          controlName: ['zip'],
          placeholder: 'GENERIC_ZIP',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['country', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'select',
          label: 'GENERIC_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_STATUS',
          data: 'statusFilter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_COMPANY',
          controlName: ['companyName'],
          placeholder: 'GENERIC_COMPANY',
          presentation: 'filter',
          options: {
            show: true
          }
        },
      ]
    }
  }
  getConfigSiteFilter2(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_ADDRESS',
          controlName: ['line1'],
          placeholder: 'GENERIC_ADDRESS',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CITY',
          controlName: ['city'],
          placeholder: 'GENERIC_CITY',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_EXTERNAL_ID',
          controlName: ['extId'],
          placeholder: 'GENERIC_EXTERNAL_ID',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_ZIP',
          controlName: ['zip'],
          placeholder: 'GENERIC_ZIP',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['country', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'select',
          label: 'GENERIC_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_STATUS',
          data: 'statusFilter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
      ]
    }
  }
  // -------------
  // player filter
  // --------------
  // group config
  getPlayersConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigPlayerFilter()
      ]
    }
  }
  getSubscriptionFilterBillingRole(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSubFilter2()
      ]
    }
  }
  getSubscriptionFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSubFilter()
      ]
    }
  }
  getSubscriptionFilterSimple(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSubFilterSimple()
      ]
    }
  }
  getProjectsFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigProjectFilter()
      ]
    }
  }

  getConfigSubFilter2(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_SUBSCRIPTION_NAME',
          controlName: ['subscriptionName'],
          placeholder: 'GENERIC_SUBSCRIPTION_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },

        {
          type: 'datePicker',
          label: 'ORDERS_LIST_DELIVERY_DATE',
          controlName: ['deliveryDate'],
          placeholder: 'ORDERS_LIST_DELIVERY_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            value: 'id',
            vue: 'name'
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'GENERIC_PRODUCT',
          data: 'productsCompleteList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_LIST_STATUS',
          data: 'statusFilter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
      ]
    }
  }
  getConfigProjectFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'PROJECT_LIST_NAME',
          controlName: ['Name'],
          placeholder: 'PROJECT_LIST_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'PROJECT_LIST_SF_PROJECT_ID',
          controlName: ['sfProjectID'],
          placeholder: 'PROJECT_LIST_SF_PROJECT_ID',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'PROJECT_SAP_PROJECT_ID',
          controlName: ['sapProjectID'],
          placeholder: 'PROJECT_SAP_PROJECT_ID',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        // {
        //   type: 'datePicker',
        //   label: 'GENERIC_CREATED',
        //   controlName: ['created'],
        //   placeholder: 'GENERIC_CREATED',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     datePicker: {
        //       minDate: false,
        //       useCurrent: false,
        //       defaultDate: null
        //     }
        //   },
        //   presentation: 'filter'
        // },
        // {
        //   type: 'datePicker',
        //   label: 'GENERIC_UPDATED',
        //   controlName: ['updated'],
        //   placeholder: 'GENERIC_UPDATED',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     datePicker: {
        //       minDate: false,
        //       useCurrent: false,
        //       defaultDate: null
        //     }
        //   },
        //   presentation: 'filter'
        // },
      ]
    }
  }
  getConfigSubFilterSimple(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_SUBSCRIPTION_NAME',
          controlName: ['subscriptionName'],
          placeholder: 'GENERIC_SUBSCRIPTION_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'PLAYER_SITE',
          controlName: ['siteName'],
          placeholder: 'PLAYER_SITE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            value: 'id',
            vue: 'name'
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'GENERIC_PRODUCT',
          data: 'productsCompleteList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_LIST_STATUS',
          data: 'statusFilter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        }
      ]
    }
  }

  getConfigSubFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_SUBSCRIPTION_NAME',
          controlName: ['subscriptionName'],
          placeholder: 'GENERIC_SUBSCRIPTION_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CONTRACT_NAME',
          controlName: ['contractName'],
          placeholder: 'GENERIC_CONTRACT_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'dateRangePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['startBillingRangeStart' , 'startBillingRangeEnd'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'GENERIC_END_DATE',
          controlName: ['endBillingRangeStart' , 'endBillingRangeEnd'],
          placeholder: 'GENERIC_END_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'ORDERS_LIST_DELIVERY_DATE',
          controlName: ['deliveryDateRangeStart' , 'deliveryDateRangeEnd'],
          placeholder: 'ORDERS_LIST_DELIVERY_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            value: 'id',
            vue: 'name'
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'GENERIC_PRODUCT',
          data: 'productsCompleteList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_LIST_STATUS',
          data: 'statusFilter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_PRICE',
          controlName: ['price'],
          placeholder: 'GENERIC_PRICE',
          presentation: 'filter',
          options: {
            show: true,
            inputType: {
              type: 'number',
              step: 0.1
            }
          }
        },
      ]
    }
  }
  getConfigPlayerFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_PLAYER_NAME',
          controlName: ['displayName'],
          placeholder: 'GENERIC_PLAYER_NAME',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'datePicker',
          label: 'SITE_FILTER_LAST_CONNECTION',
          controlName: ['lastConnection'],
          placeholder: 'SITE_FILTER_LAST_CONNECTION',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'SITE_FILTER_IS_DEFAULT',
          controlName: ['isDefault', 'id'],
          placeholder: 'SITE_FILTER_IS_DEFAULT',
          data: 'isDefaultList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_DEVICE_ID',
          controlName: ['deviceID'],
          placeholder: 'GENERIC_DEVICE_ID',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_DEVICE_MODEL',
          controlName: ['deviceModel', 'id'],
          placeholder: 'GENERIC_DEVICE_MODEL',
          data: 'deviceModel',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PRODUCT_NAME',
          controlName: ['productID', 'id'],
          placeholder: 'GENERIC_PRODUCT_NAME',
          data: 'productsBySite',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'SITE_FILTER_DEVICE_FRIMWARE',
          controlName: ['deviceFirmware'],
          placeholder: 'SITE_FILTER_DEVICE_FRIMWARE',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'SITE_FILTER_MAC_ADDRESS',
          controlName: ['deviceMacAddress'],
          placeholder: 'SITE_FILTER_MAC_ADDRESS',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'checkBox',
          label: 'SITE_FILTER_PLAYER_SHOW_HISTORY',
          controlName: ['showHistory'],
          placeholder: 'SITE_FILTER_PLAYER_SHOW_HISTORY',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        }
      ]
    }
  }

  // -------------
  // player add
  // --------------
  // group config
  getPlayersAddConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigAddPlayerFilter()
      ]
    }
  }
  getConfigAddPlayerFamiliesWithBritgh(): GroupConfig {
    return {
       'config': [
      {
        type: 'select',
        label: 'GENERIC_FAMILIES',
        controlName: ['familiesName', 'name'],
        placeholder: 'GENERIC_FAMILIES',
        data: 'families',
        options: {
          show: true,
          value: 'name',
          vue: 'name',
          labelShowInDetail: true,
          inputOptions: false
        },
        presentation: 'detail'
      },
      {
        type: 'input',
        label: 'GENERIC_ADOPTION_CODE',
        controlName: ['code'],
        placeholder: 'GENERIC_ADOPTION_CODE',
        presentation: 'edit',
        options: {
          show: true,
          labelShowInDetail: true,
          hideAll: 'show'
        }
      },
      {
        type: 'multiselect',
        label: 'ORDER_FORM_SITE_CONCEPTS',
        controlName: ['concepts', 'id'],
        placeholder: 'ORDER_FORM_SITE_CONCEPTS',
        data: 'concepts',
        options: {
          show: true,
          value: 'id',
          vue: 'name',
          labelShowInDetail: true
        },
        presentation: 'edit'
      },
      {
           type: 'select',
           label: 'Product model',
           controlName: ['bsnProductModel', 'name'],
           placeholder: 'Product model',
           data: 'bnsProductList',
           options: {
             show: true,
             value: 'id',
             vue: 'name',
             labelShowInDetail: true,
             inputOptions: false,
             allowOptionEmpty: false,
           },
           presentation: 'edit'
         },
      {
        type: 'checkBox',
        label: 'GENERIC_IS_DEFAULT',
        controlName: ['isDefault'],
        placeholder: 'GENERIC_IS_DEFAULT',
        presentation: 'edit',
        options: {
          show: true,
          labelPosition: 'left'
        }
      },
    ]
  }
  }
  getConfigAddPlayerFamilies(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'GENERIC_FAMILIES',
          controlName: ['familiesName', 'name'],
          placeholder: 'GENERIC_FAMILIES',
          data: 'families',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: true,
            inputOptions: false
          },
          presentation: 'detail'
        },
        {
          type: 'input',
          label: 'GENERIC_ADOPTION_CODE',
          controlName: ['code'],
          placeholder: 'GENERIC_ADOPTION_CODE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            hideAll: 'show'
          }
        },
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CONCEPTS',
          controlName: ['concepts', 'id'],
          placeholder: 'ORDER_FORM_SITE_CONCEPTS',
          data: 'concepts',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'GENERIC_IS_DEFAULT',
          controlName: ['isDefault'],
          placeholder: 'GENERIC_IS_DEFAULT',
          presentation: 'edit',
          options: {
            show: true,
            labelPosition: 'left'
          }
        },
      ]
    }
  }
  getConfigAddPlayerFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'typeAhead',
          label: 'GENERIC_PLAYERS',
          controlName: ['name', 'id'],
          placeholder: 'GENERIC_PLAYERS',
          data: 'device',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'GENERIC_IS_DEFAULT',
          controlName: ['isDefault'],
          placeholder: 'GENERIC_IS_DEFAULT',
          presentation: 'edit',
          options: {
            show: true,
            labelPosition: 'left'
          }
        }
      ]
    }
  }

  // --------------
  // subscription
  // --------------
  // group config
  getSubscriptionConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSite(),
        this.getConfigSubscription(),
        this.getConfigServer(),
        this.getConfigVideoOptions(),
        this.getConfigAudioOptions(),
        this.getConfigPlayerConfigurations(),
        this.getConfigConcepts(),
      ]
    }
  }
  getSubscriptionDetailConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
       // this.getConfigSite(),
        this.getConfigSubscriptionDetail(),
        this.getConfigServer(),
        this.getConfigVideoOptions(),
        this.getConfigAudioOptions(),
        this.getConfigPlayerConfigurations(),
        this.getConfigConcepts(),
      ]
    }
  }
  getSubscriptionDetailConfigsSimple(): GroupConfigs {
    return {
      'groupConfigs': [
        // this.getConfigSite(),
        this.getConfigSubscriptionSimple(),
      ]
    }
  }
  getSiteConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSiteMulti(),
       // this.getConfigSubscription(),
        this.getConfigPlayerConfigurations(),
      ]
    }
  }
  getConfigSubscriptionDetail(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'detail'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          controlName: ['product', 'id'],
          placeholder: 'product',
          data: 'products',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_STATUS',
          presentation: 'edit',
          data: 'statusAll',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          }
        },
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CULTURES',
          controlName: ['cultures', 'code'],
          placeholder: 'ORDER_FORM_SITE_CULTURES',
          data: 'cultures',
          options: {
            show: true,
            value: 'code',
            vue: 'englishName',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'IS_SOLD',
          controlName: ['isSold'],
          placeholder: 'IS_SOLD',
          presentation: 'edit',
          options: {
            show: true,
            labelPosition: 'left'
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_STATUTORY_NAME',
          controlName: ['statutoryName'],
          placeholder: 'ORDER_FORM_STATUTORY_NAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  }
  getConfigSubscriptionSimple(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'service',
          data: 'servicesList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'detail'
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
          controlName: ['product', 'id'],
          placeholder: 'product',
          data: 'products',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_STATUS',
          presentation: 'edit',
          data: 'statusAll',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          }
        },
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CULTURES',
          controlName: ['cultures', 'code'],
          placeholder: 'ORDER_FORM_SITE_CULTURES',
          data: 'cultures',
          options: {
            show: true,
            value: 'code',
            vue: 'englishName',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigSubscription(): GroupConfig {
  return {
    'config': [
      {
        type: 'input',
        label: 'GENERIC_NAME_LABEL',
        controlName: ['name'],
        placeholder: 'GENERIC_NAME_LABEL',
        presentation: 'edit',
        options: {
          show: true,
          labelShowInDetail: false
        }
      },
      {
        type: 'select',
        label: 'GENERIC_SERVICES_LABEL',
        controlName: ['service', 'id'],
        placeholder: 'service',
        data: 'servicesList',
        options: {
          show: true,
          value: 'id',
          vue: 'name',
          labelShowInDetail: true
        },
        presentation: 'detail'
      },
      {
        type: 'select',
        label: 'ORDER_FORM_SUBSCRIPTION_PRODUCT',
        controlName: ['product', 'id'],
        placeholder: 'product',
        data: 'products',
        options: {
          show: true,
          value: 'id',
          vue: 'name',
          labelShowInDetail: true
        },
        presentation: 'edit'
      },
      {
        type: 'select',
        label: 'GENERIC_LIST_STATUS',
        controlName: ['status', 'id'],
        placeholder: 'ORDER_FORM_SUBSCRIPTION_STATUS',
        presentation: 'edit',
        data: 'statusAll',
        options: {
          show: true,
          value: 'id',
          vue: 'name',
          labelShowInDetail: true
        }
      },
      {
        type: 'multiselect',
        label: 'ORDER_FORM_SITE_CULTURES',
        controlName: ['cultures', 'code'],
        placeholder: 'ORDER_FORM_SITE_CULTURES',
        data: 'cultures',
        options: {
          show: true,
          value: 'code',
          vue: 'englishName',
          labelShowInDetail: true
        },
        presentation: 'edit'
      },
      {
        type: 'checkBox',
        label: 'IS_SOLD',
        controlName: ['isSold'],
        placeholder: 'IS_SOLD',
        presentation: 'edit',
        options: {
          show: true,
          labelPosition: 'left'
        }
      },
      {
        type: 'input',
        label: 'ORDER_FORM_STATUTORY_NAME',
        controlName: ['statutoryName'],
        placeholder: 'ORDER_FORM_STATUTORY_NAME',
        presentation: 'edit',
        options: {
          show: true,
          labelShowInDetail: true
        }
      },
    ]
  }
}
  getConfigSite(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['displayName'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_SITE_EXTERNAL_ID',
          controlName: ['extId'],
          placeholder: 'extId',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SITE_TIMEZONE',
          controlName: ['timezone', 'ianaCode'],
          placeholder: 'timezone',
          data: 'timezone',
          options: {
            show: true,
            value: 'ianaCode',
            vue: 'ianaCode',
            labelShowInDetail: true
          },
          presentation: 'edit'
        }
      ]
    }
  }
  getConfigSiteMulti(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['displayName'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_SITE_EXTERNAL_ID',
          controlName: ['extId'],
          placeholder: 'extId',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_SITE_TIMEZONE',
          controlName: ['timezone', 'ianaCode'],
          placeholder: 'timezone',
          data: 'timezone',
          options: {
            show: true,
            value: 'ianaCode',
            vue: 'ianaCode',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigServer(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_FORM_CMS',
          controlName: ['cms', 'id'],
          placeholder: 'ORDER_FORM_CMS',
          data: 'cms',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
        // {
        //   type: 'select',
        //   label: 'ORDER_FORM_SERVERS',
        //   controlName: ['server', 'id'],
        //   placeholder: 'ORDER_FORM_SERVERS',
        //   data: 'servers',
        //   options: {
        //     show: true,
        //     value: 'id',
        //     vue: 'name',
        //     labelShowInDetail: true
        //   },
        //   presentation: 'edit'
        // },
        {
          type: 'select',
          label: 'ORDER_FORM_URL',
          controlName: ['url' , 'id'],
          placeholder: 'ORDER_FORM_URL',
          presentation: 'edit',
          data: 'serversUrl',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
        },

      ]
    }
  }
  getConfigAudioOptions(): GroupConfig {
    return {
      'config': [
        // {
        //   type: 'select',
        //   label: 'licence',
        //   controlName: ['licence', 'id'],
        //   placeholder: 'licence',
        //   data: 'licences',
        //   options: {
        //     show: true,
        //     value: 'id',
        //     vue: 'name',
        //     labelShowInDetail: true
        //   },
        //   presentation: 'edit'
        // },
        {
          type: 'checkBox',
          label: 'cd',
          controlName: ['cd'],
          placeholder: 'cd',
          presentation: 'edit',
          options: {
            show: true,
            labelPosition: 'left'
          }
        }
      ]
    }
  }
  getConfigVideoOptions(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'ORDER_FORM_SUBSCRIPTION_SCREEN_ORIENTATION',
          controlName: ['screenRotation', 'id'],
          placeholder: 'ORDER_FORM_SUBSCRIPTION_SCREEN_ORIENTATION',
          data: 'screenRotation',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true,
            allowOptionEmpty: false
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigConcepts(): GroupConfig {
    return {
      'config': [
        {
          type: 'multiselect',
          label: 'ORDER_FORM_SITE_CONCEPTS',
          controlName: ['concepts', 'id'],
          placeholder: 'ORDER_FORM_SITE_CONCEPTS',
          data: 'concepts',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigRemovePlayer(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'REMOVE_PLAYER_LIST',
          controlName: ['playerList', 'deviceID'],
          placeholder: 'REMOVE_PLAYER_LIST',
          data: 'Players',
          options: {
            show: true,
            value: 'deviceID',
            vue: 'name',
            labelShowInDetail: true,
            allowOptionEmpty: false
          },
          presentation: 'edit',
        }
      ]
    }
  }
  getConfigRemovePlayerLostOrSold(): GroupConfig {
      return {
        'config': [
          {
            type: 'textarea',
            label: 'textarea',
            controlName: [ 'reason'],
            placeholder: 'textarea',
            presentation: 'edit',
            options: {
              show: true,
              labelShowInDetail: false
            }
          }
        ]
      }
  }

  // --------------
  // network
  // --------------
  // group config
  getNetworkConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigOrderService.getConfigOrderSubNetworkIpAddress(),
        this.getConfigOrderService.getConfigOrderSubNetworkProxy(),
        this.getConfigOrderService.getConfigOrderSubNetworkWifi()
      ]
    }
  }

  // --------------
  // addresses
  // --------------
  // group config
  getAddressesConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigOrderService.getConfigOrderAddress()
      ]
    }
  }

  // --------------
  // contact
  // --------------
  // group config
  getContactConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigOrderService.getConfigOrderContact()
      ]
    }
  }

  // --------------
  // miscellaneous
  // --------------
  // group config
  getMiscellaneousConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.information(),
        this.getConfigComments()
      ]
    }
  }
  information(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'Created',
          controlName: ['created'],
          placeholder: 'created',
          presentation: 'edit',
          options: {
            show: false,
            shortInput: true,
            concatenate: ['createdBy', 'created'],
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'CreatedBy',
          controlName: ['createdBy'],
          placeholder: 'createdBy',
          presentation: 'edit',
          options: {
            show: false,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'Updated',
          controlName: ['updated'],
          placeholder: 'updated',
          presentation: 'edit',
          options: {
            show: false,
            shortInput: true,
            concatenate: ['updatedBy', 'updated'],
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'UpdatedBy',
          controlName: ['updatedBy'],
          placeholder: 'updatedBy',
          presentation: 'edit',
          options: {
            show: false,
            labelShowInDetail: false
          }
        }
      ]
    }
  }
  getConfigComments(): GroupConfig {
    return {
      'config': [
        {
          type: 'textarea',
          label: '',
          controlName: ['commentsBlog'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'textarea',
          label: '',
          controlName: ['comments'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        }
      ]
    }
  }

  // --------------
  // player config
  // --------------
  // group config
  getPlayerConfigurationsConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigPlayerConfigurations()
      ]
    }
  }
  getConfigPlayerConfigurations(): GroupConfig {
    return {
      'config': []
    }
  }

  // -------------
  // Publication filter
  // --------------
  // group config
  getPublicationsConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigPublicationFilter()
      ]
    }
  }
  getConfigPublicationFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_PUBLICATION_NAME',
          controlName: ['name'],
          placeholder: 'GENERIC_PUBLICATION_NAME',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_PUBLICATION_PACKAGE_ID',
          controlName: ['packageID'],
          placeholder: 'GENERIC_PUBLICATION_PACKAGE_ID',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_PUBLICATION_TYPE',
          controlName: ['type', 'id'],
          placeholder: 'GENERIC_PUBLICATION_TYPE',
          data: 'publicationTypes',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_PUBLICATION_VERSION',
          controlName: ['version'],
          placeholder: 'GENERIC_PUBLICATION_VERSION',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_PUBLICATION_STARTDATE',
          controlName: ['startDate'],
          placeholder: 'GENERIC_PUBLICATION_STARTDATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              daysOfWeekDisable: false,
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_PUBLICATION_ENDDATE',
          controlName: ['endDate'],
          placeholder: 'GENERIC_PUBLICATION_ENDDATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              daysOfWeekDisable: false,
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_PUBLICATION_CREATED',
          controlName: ['created'],
          placeholder: 'GENERIC_PUBLICATION_CREATED',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              daysOfWeekDisable: false,
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PUBLICATION_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_PUBLICATION_STATUS',
          data: 'PublicationStatus',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PUBLICATION_TRANSFERMODE',
          controlName: ['sent', 'id'],
          placeholder: 'GENERIC_PUBLICATION_TRANSFERMODE',
          data: 'deliveryTransferModes',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        }
      ]
    }
  }

  getMergeSubscriptionOfClient(): GroupConfig {
    return {
      'config': [
        {
          type: 'typeAhead',
          label: 'SITE_LIST_MERGE_SUBSCRIPTION_SITE_INPUT',
          controlName: ['siteName', 'siteUuid'],
          placeholder: 'SITE_LIST_MERGE_SUBSCRIPTION_SITE_INPUT',
          data: 'sites',
          options: {
            show: true,
            value: 'uuid',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        }
      ]
    }
  }
  getMergeSubscriptionOfClientNewSite(): GroupConfig {
  return {
    'config': [
      {
        type: 'input',
        label: 'SITE_LIST_MERGE_SUBSCRIPTION_SITE_NEW_NAME',
        controlName: ['NewSiteName'],
        placeholder: 'SITE_LIST_MERGE_SUBSCRIPTION_SITE_NEW_NAME',
        presentation: 'edit',
        options: {
          show: true,
          labelShowInDetail: true
        }
      },
      {
        type: 'input',
        label: 'SITE_LIST_MERGE_SUBSCRIPTION_SITE_NEW_EXTERNAL_ID',
        controlName: ['NewSiteExternalID'],
        placeholder: 'SITE_LIST_MERGE_SUBSCRIPTION_SITE_NEW_EXTERNAL_ID',
        presentation: 'edit',
        options: {
          show: true,
          labelShowInDetail: true
        }
      },
    ]
  }
}
  getMergeSiteOfClient(): GroupConfig {
    return {
      'config': [
        {
          type: 'typeAhead',
          label: 'SITE_LIST_MERGE_SITE_CLIENT_INPUT',
          controlName: ['clientName', 'clientUuid'],
          placeholder: 'SITE_LIST_MERGE_SITE_CLIENT_INPUT',
          data: 'clients',
          options: {
            show: true,
            value: 'uuid',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        }
      ]
    }
  }
  getBulkUpdate(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'GENERIC_PUBLICATION_TRANSFERMODE',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_PUBLICATION_TRANSFERMODE',
          data: 'deliveryTransferModes',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'detail'
        }
      ]
    }
  }
}
